import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import fetchMiddleware from '../middlewares/fetch'
import rootReducer from '../reducers'
import {persistStore} from 'redux-persist'

const configureStore = preloadedState => {
  let store = createStore(
    rootReducer,
    preloadedState,
    compose(applyMiddleware(thunk, fetchMiddleware))
  )

  let persistor = persistStore(store)

  return { store, persistor }
}

export default configureStore



// WEBPACK FOOTER //
// ./src/store/configureStore.js